<div class="checkout">
  <div class="hidden lg:block">
    <div class="mb-6 flex items-center">
      <div class="mr-4 h-1 w-6 bg-primary-md-dark lg:w-12"></div>
      <div class="text-xl font-medium text-primary-darkest lg:text-3xl">
        Checkout
      </div>
    </div>
  </div>
  <div class="checkout-list">
    <div
      class="checkout-card mb-5 rounded-lg p-4 shadow-md"
      *ngFor="let checkout of checkouts">
      <div class="content flex w-full flex-wrap justify-between gap-5">
        <div class="checkout-detail flex w-full gap-3">
          <div
            class="checkout-icon-wrapper h-10 w-10 rounded-full bg-primary-light p-2 px-2.5">
            <div class="checkout-icon text-primary-darkest">
              <fa-icon [icon]="faMoneyCheckAlt" class="icon"></fa-icon>
            </div>
          </div>
          <div class="w-full justify-between gap-4 lg:flex">
            <div class="flex-1">
              <div class="detail">
                <div class="fs-16 font-bold text-primary-darkest">Checkout</div>
                <div class="checkout-information fs-14 mb-2 flex flex-wrap">
                  <div class="info-item total align-center mr-2">
                    <span class="label mr-1 text-primary-md-dark">Total:</span>
                    <span class="value font-bold text-secondary-main">{{
                      checkout.amount_to_paid | fcCurrency
                    }}</span>
                  </div>
                  <div class="info-item date align-center hidden lg:block">
                    <span class="label mr-1 text-primary-md-dark"
                      >Transaction Date:</span
                    >
                    <span class="value font-bold text-primary-darkest">{{
                      checkout.formatted_transaction_time
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="payment-info">
                <div
                  class="pay-before mb-2 rounded-lg bg-primary-light p-1 px-2 text-stone-800">
                  Pay Before
                  <b class="text-primary-darkest">{{
                    checkout.paymentDeadline
                  }}</b>
                </div>
                <div class="info-item block text-primary-md-dark lg:hidden">
                  <span class="label mr-1">Transaction Date:</span>
                  <span class="value font-bold text-primary-darkest">{{
                    checkout.formatted_transaction_time
                  }}</span>
                </div>
                <div class="info-item">
                  <span class="label mr-2 text-primary-md-dark"
                    >Payment Method :</span
                  >
                  <span class="value font-bold text-primary-darkest">{{
                    checkout.payment_method_name
                  }}</span>
                </div>
                <div
                  class="info-item"
                  *ngIf="checkout.happy_pay_partial_amount > 0">
                  <span class="label mr-2">Paid with Happy Pay :</span>
                  <span class="value">{{
                    checkout.happy_pay_partial_amount | fcCurrency
                  }}</span>
                </div>
              </div>
            </div>
            <div class="checkout-action my-3">
              <div class="c-btn-group-rtl second-button flex gap-5">
                <button
                  class="btn-p-md-dark-l c-md-btn-block text-primary-md-dark"
                  [routerLink]="['/user/invoice', checkout.id]">
                  View Invoice
                </button>
                <button
                  class="btn-s-main-l c-md-btn-block text-secondary-main"
                  (click)="cancelCheckout(checkout.id)">
                  Cancel Checkout
                </button>
              </div>
              <div
                class="pay-now-wrapper mt-2"
                *ngIf="checkout.payment_method != 0">
                <button
                  class="btn-p-darkest-o c-btn-group w-full rounded-lg border border-primary-darkest px-10 py-1 text-primary-darkest"
                  (click)="makePayment(checkout)">
                  Make Payment
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="load-more mb-5 flex justify-center"
    *ngIf="!hideLoadMore && !loadMoreLoading">
    <button
      type="button"
      class="px-3 py-2 text-primary-darkest hover:rounded-lg hover:bg-primary-light"
      (click)="loadCheckouts()"
      [disabled]="loadMoreLoading">
      <span class="btn-label"
        >Show more
        <fa-icon class="ml-1" [icon]="faChevronDown"></fa-icon>
      </span>
    </button>
  </div>
  <div class="mt-5 flex flex-col justify-center" *ngIf="loadMoreLoading">
    <p-skeleton
      class="my-2 max-w-2xl md:max-w-full"
      height="132px"></p-skeleton>
  </div>
</div>
